import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import TrainingProgramsApi from './TrainingProgramsApi';

let settings;

export default settings = {
    key: 'training/programs',
    zone: 'training',
    path: '/training/programs',
    title: "Training Programs",
    endpoint: TrainingProgramsApi.endpoint,
    modelName: 'TrainingPrograms',
    idKey: 'id',
    primaryKey: 'title',
    actions: ["trash", "clone"],
    indexCaps: ["viewTrainingPrograms"],
    viewCaps: ["viewTrainingPrograms"],
    createCaps: ["createTrainingPrograms"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            // {
            //     label: "Draft",
            //     path: settings.path + "/status/draft",
            //     caps: settings.indexCaps
            // },
            // {
            //     label: "Preview",
            //     path: settings.path + "/status/preview",
            //     caps: settings.indexCaps
            // },
            // {
            //     label: "Live",
            //     path: settings.path + "/status/live",
            //     caps: settings.indexCaps
            // },
            // {
            //     label: "Hidden",
            //     path: settings.path + "/status/hidden",
            //     caps: settings.indexCaps
            // },
            {
                label: "Re-Order",
                path: settings.path + "/reorder",
                caps: settings.createCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: TrainingProgramsApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ['activity'], order: ["order asc", 'created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['title'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Title",
                key: "title",
                type: "text",
            },
            {
                label: "Sport / Activity",
                key: "activityId",
                type: "relationship",
                model: "SportsActivities",
            },
            {
                label: "Status",
                key: "status",
                type: "choice",
                options: [
                    { value: "draft", label: "Draft" },
                    { value: "preview", label: "Preview" },
                    { value: "live", label: "Live" },
                ]
            },
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Title",
                key: "this",
                format: "ModelLink",
            },
            {
                label: "Sport / Activity",
                key: "activity",
                format: "modelLink",
            },
            {
                label: "Status",
                key: "status",
                format: "titleCase",
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                format: "actions",
                api: TrainingProgramsApi,
                settings: settings,
            }
        ];

        return columns;

    },
    singleFetch: TrainingProgramsApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['activity'] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit"
            },
        ]

    },
};